import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import ParentLayout from '../ParentLayout';
import Urls from '../Urls';
import Form from './Form';
import RatingTitle from '../RatingTitle';
import useRouter from '../../../hooks/useRouter';
import useEvaluationNavigation from '../useEvaluationNavigation';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const evaluation = useConnect('evaluationEventEducator.byId', {
    id: Number(match.params.evaluationId)
  });

  const navigation = useEvaluationNavigation(evaluation, Urls(evaluation).ENGAGED);

  if (evaluation.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      evaluation={evaluation}
      page="Engagement"
      title={(
        <RatingTitle>
          were more engaged in learning
        </RatingTitle>
      )}
    >
      <Form
        user={user}
        evaluation={evaluation}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls(evaluation).STUDENTS)}
        onNext={(newData) => history.push(Urls(evaluation).SKILLS)}
        onSkip={() => history.push(Urls(evaluation).SKILLS)}
        onExit={() => history.push(Urls(evaluation).EVENT_VIEW)}
      />
    </ParentLayout>
  );
};
